// import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import SectionDivider from './_sectionDivider';
import ScoreCharts from './_scoreCharts';
import SubSection from './_subSection';
import { date2str } from 'utils/date';
import { useTranslation } from 'react-i18next';

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
}));

export interface IScore {
  kosmosEsgScore: number;
  kosmosEsgEnvironmentScore?: number;
  kosmosEsgSocialScore?: number;
  kosmosEsgGovernanceScore?: number;
  reportDate?: string;
}

interface IProps {
  name: string;
  address: string;
  companyRegistrationNumber: string;
  automatedScore?: IScore;
  smartGovernanceScore?: IScore;
  reportId: string;
}

export default function IndicativeRegulatoryReport(props: IProps): JSX.Element {
  const {
    name,
    reportId,
    address,
    companyRegistrationNumber,
    automatedScore,
    smartGovernanceScore,
  } = props;
  const { t } = useTranslation('default');
  const renderProperty = (label: string, value: string | number) => {
    if (value) {
      return (
        <div style={{ marginTop: 25 }}>
          <label>{label}</label>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
            {value}
          </Typography>
        </div>
      );
    }
  };

  return (
    <Root>
      <SubSection isBold title={name}>
        <>
          {renderProperty(t('registered-office-address'), address)}
          {renderProperty(t('score'), automatedScore?.kosmosEsgScore || '')}
          {renderProperty(t('company-number'), companyRegistrationNumber)}
          {renderProperty(t('report-number'), reportId)}
          {renderProperty(
            t('report-date'),
            date2str(automatedScore?.reportDate || '', 'DD-MMM-YYYY'),
          )}
        </>
      </SubSection>
      <SectionDivider color="#dddddd" id="esg-ratings" />
      <ScoreCharts automatedScore={automatedScore} smartGovernanceScore={smartGovernanceScore} />
    </Root>
  );
}
